<template>
  <div>
    <h1>Dashboard</h1>

    <section class="mb-8">
      <h3>Account Details</h3>
      <VForm
        @submit.prevent="onEdit"
        class="dash__edit-form grid gap-4 align-end"
      >
        <label>
          Username
          <input name="username" :value="user.username" :disabled="!editing" />
        </label>
        <label>
          Email
          <input name="email" :value="user.email" :disabled="!editing" />
        </label>

        <button :disabled="!editing" type="submit">Save</button>
        <button @click="editing = !editing" type="button">
          {{ editing ? "Cancel" : "Edit" }}
        </button>
      </VForm>
    </section>

    <section class="mb-8">
      <h3>Subscriptions</h3>
      <RouterLink :to="{ name: 'Add Card' }">Add a card</RouterLink>

      <VAsync :await="subscriptionsRequest">
        <template #pending><PLoader /></template>

        <template #rejected="error"><PError :error="error" /></template>

        <template #resolved="response">
          <VTable
            :headers="[
              { key: 'id' },
              { key: 'quantity' },
              { key: 'plan' },
              { key: 'status' },
            ]"
            :items="response.data"
          >
            <template #column.plan="{ cell }">
              {{ (cell.amount / 100) | currency }}/month
            </template>
          </VTable>
          <!-- <pre>{{ response }}</pre> -->
        </template>
      </VAsync>
    </section>

    <section class="mb-8">
      <h2>Connected Accounts</h2>

      <PlaidLink @success="onPlaidLink" />

      <VAsync :await="accountsRequest">
        <template #pending><PLoader /></template>
        <template #rejected="error"><PError :error="error" /></template>

        <template #resolved="response">
          <p>
            {{ response.meta.institution.name }}:
            {{ response.meta.account.name }} (ends in
            {{ response.meta.account.mask }})
          </p>
          <a href="#">{{ response.meta.account_id }}</a>
        </template>
      </VAsync>
    </section>

    <section>
      <h2>Transactions</h2>

      <VAsync :await="txRequest">
        <template #pending><PLoader /></template>
        <template #rejected="error"><PError :error="error" /></template>

        <template #resolved="response">
          <p>Total: {{ response.total_transactions }}</p>
          <VTable
            v-if="response.transactions.length"
            :headers="[{ key: 'id' }]"
            :items="response.transactions"
          ></VTable>
        </template>
      </VAsync>
    </section>
  </div>
</template>

<script>
// @ts-check
import { API } from "../config"
import store from "../store"
import http from "../http"
import PlaidLink from "@/components/PlaidLink.vue"

export default {
  components: {
    PlaidLink,
  },

  data() {
    return {
      editing: false,
      subscriptionsRequest: null,
      accountsRequest: null,
      accountId: null,
      txRequest: null,
      transactins: [],
    }
  },

  computed: {
    user: store.get.user,
    auth: store.get.auth,
    totalSpent() {
      return this.transactions.reduce((total, tx) => {
        // TODO
        return total + 1
      }, 0)
    },
  },

  watch: {
    accountId(id) {
      this.getTxs(id)
    },
  },

  mounted() {
    this.getCards()
    this.getAccounts()
  },

  methods: {
    getCards() {
      const { token } = this.auth
      this.subscriptionsRequest = http.get(`${API}/my-subscriptions`, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      })
    },

    getAccounts() {
      const { token } = this.auth
      this.accountsRequest = http
        .get(`${API}/my-accounts`, {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        })
        .then(({ data }) => {
          this.accountId = data.meta.account_id
          return data
        })
    },

    onPlaidLink(publicToken, meta) {
      const { token } = this.auth

      http.post(`${API}/plaid`, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
        json: { publicToken, meta },
      })
    },

    getTxs(id) {
      const { token } = this.auth
      this.txRequest = http
        .get(`${API}/transactions/${id}`, {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        })
        .then(res => {
          this.transactions = res.transactions
          return res
        })
    },
  },
}
</script>

<style lang="scss">
.dash__edit-form {
  grid-template-columns: 1fr 1fr auto auto auto;
}
</style>
